import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const WarningIcon = React.forwardRef<SVGSVGElement, IconProps>(function WarningIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="M1 21.5h22l-11-19zm12-3h-2v-2h2zm0-4h-2v-4h2z"/>
        </IconBase>
    );
});
